import type { ProfileDto } from '../dtos/user-profile.dto'
import type { UserSessionType } from '../../types/user.types'
import { resolveUserRole } from '../../utils/resolve-user-role'

export function mapSuiteProfileToPayUserSession(profile: ProfileDto): UserSessionType {
  const role = resolveUserRole(profile.roles)
  const belongsTo = profile.userType === 'system' ? 'holdings' : profile.organizationId ?? ''

  return {
    _id: profile.uuid,
    role,
    subRole: undefined,
    username: profile.email,
    belongsTo,
    firstName: profile.name,
    lastName: profile.surname,
    adminOfPockets: []
  }
}
